import React from 'react'
import moment from 'moment'
import { Grid, Button, } from '@material-ui/core'
import excel from '../../assets/img/excel_icon.png'
import printer from '../../assets/img/Print_icon.png'
import XLSX from 'xlsx';
import FileSaver from "file-saver";

function ExportTo({ dataExcel, fileName, exportPDF, exportExcel }) {

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = (excelData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Grid container style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <h4 style={{marginRight: "1rem"}}>Export To</h4>
      <Button onClick={() => exportExcel() && exportToExcel(dataExcel, `${fileName}_${moment().format('LLL')}`)}>
        <img 
          src={excel}
          alt="excel"
        />
      </Button>
      <Button onClick={exportPDF}>
        <img
          src={printer}
          alt="printer"
        />
      </Button>
    </Grid>
  )
}

export default ExportTo
